import React from "react";
import {
  TERMS_OF_SERVICE_META,
  TERMS_PROMISES,
  TERMS_SECTIONS,
} from "../app/utils/termsOfServiceContent";

const Section = ({ title, children }) => (
  <div className="bg-black border border-[#1E88E5]/10 rounded-2xl p-6 mb-4">
    <h3 className="text-lg font-semibold text-white mb-2 flex items-center gap-2">
      <span className="w-2 h-2 rounded-full bg-[#1E88E5]" />
      {title}
    </h3>
    <div className="text-gray-300 text-sm leading-6">{children}</div>
  </div>
);

const renderBlock = (block, key) => {
  if (block.bullets?.length) {
    return (
      <div key={key} className="mb-3 last:mb-0">
        {block.prose ? <p className="mb-2">{block.prose}</p> : null}
        <ul className="list-disc list-inside space-y-1 ml-2">
          {block.bullets.map((item) => (
            <li key={item}>{item}</li>
          ))}
        </ul>
      </div>
    );
  }

  if (block.email) {
    return (
      <p key={key} className="mb-3 last:mb-0">
        {block.prose?.replace(block.email, "").trim()}{" "}
        <a href={`mailto:${block.email}`} className="text-[#1E88E5] hover:underline">
          {block.email}
        </a>
      </p>
    );
  }

  return (
    <p key={key} className="mb-3 last:mb-0">
      {block.prose}
    </p>
  );
};

export default function TermsOfService() {
  return (
    <div className="min-h-screen bg-black text-white pt-14 md:pt-16">
      <div className="max-w-3xl mx-auto px-4 py-10 pb-16">
        <header className="mb-6 border-b border-[#1E88E5]/10 pb-4">
          <h1 className="text-3xl font-bold">{TERMS_OF_SERVICE_META.title}</h1>
          <p className="text-gray-400 mt-2 text-sm">
            Last updated: {TERMS_OF_SERVICE_META.updatedAt}
          </p>
        </header>

        <div className="bg-gradient-to-r from-[#1E88E5]/10 to-transparent border border-[#1E88E5]/20 rounded-2xl p-6 mb-6">
          <p className="text-gray-300 text-sm leading-6 mb-3">
            {TERMS_OF_SERVICE_META.intro}
          </p>
          <p className="text-gray-300 text-sm leading-6">
            {TERMS_OF_SERVICE_META.platformNote}
          </p>
        </div>

        <div className="grid gap-3 sm:grid-cols-2 mb-6">
          {TERMS_PROMISES.map((promise) => (
            <div
              key={promise.id}
              className="rounded-2xl border border-[#1E88E5]/15 bg-white/[0.02] p-4"
            >
              <p className="text-sm font-semibold text-white">{promise.label}</p>
              <p className="mt-1 text-xs leading-5 text-gray-400">{promise.detail}</p>
            </div>
          ))}
        </div>

        {TERMS_SECTIONS.map((section) => (
          <Section key={section.id} title={`${section.index}. ${section.title}`}>
            {section.bullets?.length ? (
              <ul className="list-disc list-inside space-y-1 ml-2">
                {section.bullets.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            ) : null}
            {section.blocks?.map((block, index) => renderBlock(block, `${section.id}-${index}`))}
          </Section>
        ))}

        <div className="rounded-2xl border border-[#1E88E5]/15 bg-white/[0.02] p-5">
          <p className="text-sm text-gray-300">
            Questions about these Terms? Email{" "}
            <a href="mailto:betbondofficial@gmail.com" className="text-[#1E88E5] hover:underline">
              betbondofficial@gmail.com
            </a>
            .
          </p>
        </div>
      </div>
    </div>
  );
}
